import { UrlService } from '@/common/services/url/url.service';
import { isValid } from '@/common/utils/validation/common.utils';
import { CityDetailsResponse } from '@/core/domain/city-details/models/city-details.model';
import { GetCityDetailsUseCase } from '@/core/domain/city-details/usecases/getCityDetails.usecase';
import { LocationDetailsResponse } from '@/core/domain/location-details/models/location-details.model';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

@Component({
    selector: 'fe-city',
    templateUrl: './city.component.html',
    styleUrls: ['./city.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CityComponent implements OnInit {
    public cityDetails: CityDetailsResponse | null = null;

    private code = '';

    isImageLoadedHorizontal = true;
    isImageLoadedVertical = true;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly getCityDetailsUseCase: GetCityDetailsUseCase,
        private url: UrlService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            this.code = params.get('code') || '';
            this.getCityDetails(this.code);
        });
    }

    getCityDetails(code: string): void {
        this.getCityDetailsUseCase
            .execute(code)
            .pipe(
                catchError((error) => {
                    this.router.navigateByUrl(this.url.format(''));
                    return throwError(() => error);
                }),
            )
            .subscribe((cityDetails) => {
                this.cityDetails = cityDetails;
            });
    }

    onLocationDetailsLoaded(locationDetails: LocationDetailsResponse): void {
        if (!isValid(locationDetails)) {
            this.router.navigateByUrl(this.url.format(''), {
                replaceUrl: true,
            });
        }
    }
}
